"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Collapse_1 = __importDefault(require("@mui/material/Collapse"));
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var DatePicker_1 = __importDefault(require("shared/components/DateTimePicker/DatePicker"));
var BackDatePicker = function () {
    var _a = __read(react_1.default.useState(false), 2), showDatePicker = _a[0], setShowDatePicker = _a[1];
    var onChange = (0, react_final_form_1.useField)('backDateInvsTo').input.onChange;
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ pb: 1.25 }, { children: [!showDatePicker
                ? ((0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ color: "neutral", size: "small", onClick: function () { return setShowDatePicker(true); } }, { children: "Back-date invoice" })))
                : (0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ color: "neutral", size: "small", onClick: function () { return onChange(new Date()); } }, { children: "Today" })), (0, jsx_runtime_1.jsx)(Collapse_1.default, __assign({ in: showDatePicker }, { children: (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ ml: -9, overflow: "hidden", maxHeight: 320 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "backDateInvsTo", component: DatePicker_1.default, limitToToday: "NO_FUTURE", isStatic: true, minDate: (0, date_fns_1.sub)(new Date(), { years: 1, months: 6 }) }) })) }))] })));
};
exports.default = BackDatePicker;
